import {
  JOHAISETSU_ROLE_EAST,
  JOHAISETSU_ROLE_KANAGAWA,
  JOHAISETSU_ROLE_WEST,
} from '@/consts/johaisetsu';
import { BoardTab } from '@/models/apis/settouMessageBoard/settouMessageBoardResponse';

export const BOARD_ROLE_CREATE = 10;
export const BOARD_ROLE_REPLY = 20;

// 掲示板機能に限定して局(上位組織)として扱うためのロール一覧。
export const BOARD_KYOKU_ROLES = [
  'co_shutokou_west',
  'co_shutokou_east',
  'co_shutokou_kanagawa',
];

// co_shutokou_*ロールの初期表示タブは、自身の板(東京西局等)ではなく対応する局の板にする。
export const BOARD_KYOKU_ROLE_BUREAU_OWNER_MAP: Record<string, string> = {
  'co_shutokou_west': JOHAISETSU_ROLE_WEST,
  'co_shutokou_east': JOHAISETSU_ROLE_EAST,
  'co_shutokou_kanagawa': JOHAISETSU_ROLE_KANAGAWA,
};

export const johaisetsuRoleMap: Record<string, number> = {
  [JOHAISETSU_ROLE_WEST]: 20,
  [JOHAISETSU_ROLE_EAST]: 30,
  [JOHAISETSU_ROLE_KANAGAWA]: 40,
  'co_shutokou_west': 20,
  'co_shutokou_east': 30,
  'co_shutokou_kanagawa': 40,
};
export const departmentDispMap: Record<string, string> = {
  'west': '西局本部',
  'east': '東局本部',
  'kanagawa': '神局本部',
};
export const boardTabDefault: BoardTab = {
  id: 0,
  disp_name: '',
  board_kind: '',
  department: '',
  owner_company_name: '',
  disp_order: 999,
  johaisetsu_role: '',
  board_role: 99,
};
